import { render } from "./SelectLingue.vue?vue&type=template&id=ed612d0a"
import script from "./SelectLingue.vue?vue&type=script&lang=js"
export * from "./SelectLingue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__